function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 11.5C12.9142 11.5 13.25 11.8358 13.25 12.25V20.75C13.25 22.5449 12.2949 24 10.5 24C8.70507 24 7.75 22.5 7.75 21.25C7.75 20.8358 8.08579 20.5 8.5 20.5C8.91421 20.5 9.25 20.8358 9.25 21.25C9.25 21.6642 9.5335 22.5 10.5 22.5C11.4665 22.5 11.75 21.7165 11.75 20.75V12.25C11.75 11.8358 12.0858 11.5 12.5 11.5Z",
  fill: "#004152"
});

var _ref3 = React.createElement("path", {
  d: "M13.25 0.75C13.25 0.335786 12.9142 0 12.5 0C12.0858 0 11.75 0.335786 11.75 0.75V2.70237C11.1723 3.01282 10.5932 3.6848 10.0974 4.74806C9.41112 6.21977 8.97071 8.28138 8.96147 10.587C9.86654 10.2244 11.1178 10 12.5001 10C13.8822 10 15.1334 10.2243 16.0385 10.5869C16.0292 8.28133 15.5888 6.21975 14.9026 4.74806C14.4068 3.68484 13.8277 3.01287 13.25 2.7024V0.75Z",
  fill: "#004152"
});

var _ref4 = React.createElement("path", {
  d: "M4.70466 4.81618C2.72834 6.23818 1.56276 8.15863 1.56276 10.2293C1.56276 10.2851 1.55361 10.3388 1.53674 10.3889C2.36603 10.1445 3.39087 10 4.50007 10C5.84353 10 7.06323 10.2119 7.96161 10.5568C7.97451 8.14963 8.43387 5.94929 9.19106 4.32545C9.48462 3.69591 9.83738 3.12589 10.2436 2.66541C8.09252 2.98574 6.18107 3.75386 4.70466 4.81618Z",
  fill: "#004152"
});

var _ref5 = React.createElement("path", {
  d: "M20.5001 10C19.1565 10 17.9367 10.212 17.0383 10.5569C17.0254 8.14968 16.5661 5.9493 15.8089 4.32545C15.5153 3.69591 15.1626 3.12589 14.7563 2.66541C16.9074 2.98574 18.8189 3.75386 20.2953 4.81618C22.2716 6.23818 23.4372 8.15863 23.4372 10.2293C23.4372 10.2851 23.4463 10.3388 23.4632 10.3889C22.6339 10.1444 21.6092 10 20.5001 10Z",
  fill: "#004152"
});

var SvgUmbrella = function SvgUmbrella(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUmbrella, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/umbrella.0af09606.svg";
export { ForwardRef as ReactComponent };